import styled from 'styled-components';
import { GRAY_2 } from '../../../config/theme';

const StyledInputWrapper = styled.div`
  input:disabled {
    color: ${GRAY_2};
  }
`;

export const StyledMapIcon = styled.div`
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
`;

export default StyledInputWrapper;
